// ユーザーロールの定義
export const ROLES = {
  ADMIN: 'admin',           // 管理者：全ての権限
  CORPORATE: 'corporate',   // 企業管理ユーザー：広告投稿、フォロー、いいね、リプライ、DM
  POSTER: 'poster',         // 投稿ユーザー：ポスト投稿、フォロー、いいね、リプライ、DM
  PREMIUM: 'premium',       // プレミアムユーザー：追加機能付きの閲覧・投稿ユーザー
  VIEWER: 'viewer',         // 閲覧ユーザー：フォロー、いいね、リプライ、DM（ポスト投稿不可）
  GUEST: 'guest'            // 未ログインユーザー：タイムライン、公開プロフィールの閲覧のみ
};

// 各ロールの権限設定
export const PERMISSIONS = {
  // タイムライン閲覧権限
  VIEW_TIMELINE: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER, ROLES.GUEST],
  
  // プロフィール閲覧権限
  VIEW_PROFILE: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER, ROLES.GUEST],
  
  // 検索権限
  SEARCH: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER],
  
  // ポスト投稿権限
  POST: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM],
  
  // リツイート権限
  RETWEET: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM],
  
  // 広告投稿権限
  POST_ADS: [ROLES.ADMIN, ROLES.CORPORATE],
  
  // フォロー権限（すべてのログインユーザーが可能）
  FOLLOW: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER],
  
  // いいね権限
  LIKE: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER],
  
  // リプライ権限
  REPLY: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER],
  
  // DM権限
  SEND_DM: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER, ROLES.PREMIUM, ROLES.VIEWER],
  
  // 管理機能権限
  ADMIN_FUNCTIONS: [ROLES.ADMIN],
  
  // 統計情報閲覧権限
  VIEW_STATS: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER],
  
  // 公開リスト作成権限
  CREATE_PUBLIC_LIST: [ROLES.ADMIN, ROLES.CORPORATE, ROLES.POSTER],
  
  // 企業ユーザー登録権限
  REGISTER_CORPORATE: [ROLES.ADMIN],
  
  // 投稿ユーザー登録権限
  REGISTER_POSTER: [ROLES.ADMIN, ROLES.CORPORATE],
  
  // 投稿ユーザー専用機能権限（シフト管理など）
  POSTER_FUNCTIONS: [ROLES.ADMIN, ROLES.POSTER],
  
  // メンテナンスモード時でもアクセス可能な権限
  MAINTENANCE_ACCESS: [ROLES.ADMIN]
}; 